module.exports = __webpack_public_path__ + "static/media/logo-color.390f4598.svg";